import { Zap, Droplets, Apple, Users } from 'lucide-react'
import { useLanguage } from '../context/LanguageContext'
import { sectionImages } from '../data/imageBank'

export default function Project() {
  const { t } = useLanguage()
  const cards = [
    {
      icon: <Zap className="w-7 h-7 text-ng-gold" />,
      bg: 'bg-ng-gold/10',
      title: t('project.card1Title'),
      text: t('project.card1Text'),
    },
    {
      icon: <Droplets className="w-7 h-7 text-ng-blue" />,
      bg: 'bg-ng-blue/10',
      title: t('project.card2Title'),
      text: t('project.card2Text'),
    },
    {
      icon: <Apple className="w-7 h-7 text-ng-mid" />,
      bg: 'bg-ng-mid/10',
      title: t('project.card3Title'),
      text: t('project.card3Text'),
    },
    {
      icon: <Users className="w-7 h-7 text-ng-brown" />,
      bg: 'bg-ng-brown/10',
      title: t('project.card4Title'),
      text: t('project.card4Text'),
    },
  ]

  return (
    <section id="project" className="py-20 lg:py-32 bg-ng-beige">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* 2-col intro */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-16 lg:mb-24">
          <div>
            <span className="text-sm font-medium text-ng-brown uppercase tracking-wider">{t('project.kicker')}</span>
            <h2 className="font-display text-4xl lg:text-5xl text-ng-dark mt-3 mb-6 font-bold">
              {t('project.title')}
            </h2>
            <p className="text-lg text-ng-dark/85 leading-relaxed">
              {t('project.intro')}
            </p>
          </div>

          <div className="relative">
            <img
              src={sectionImages.project}
              alt="Restauration"
              className="rounded-2xl shadow-xl w-full h-[400px] object-cover"
              loading="lazy"
              decoding="async"
              style={{ objectPosition: '50% 60%' }}
              onError={(e) => {
                e.target.parentElement.querySelector('.img-fallback').style.display = 'flex'
                e.target.style.display = 'none'
              }}
            />
            <div
              className="img-fallback rounded-2xl shadow-xl w-full h-[400px] items-center justify-center hidden"
              style={{ background: 'linear-gradient(135deg,#c5d8c0 0%,#e8f0e4 100%)' }}
            >
              <span className="text-ng-dark/30 text-sm">restoration.jpg</span>
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-6 shadow-lg">
              <div className="font-display text-3xl font-bold text-ng-dark">SCIC</div>
              <div className="text-sm text-ng-dark/80">{t('project.coop')}</div>
            </div>
          </div>
        </div>

        {/* 4 cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map(({ icon, bg, title, text }) => (
            <div key={title} className="card-hover group bg-white rounded-2xl p-6 shadow-sm border border-ng-dark/5">
              <div className={`w-14 h-14 rounded-xl ${bg} flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}>
                {icon}
              </div>
              <h3 className="font-display text-xl text-ng-dark mb-3 font-semibold">{title}</h3>
              <p className="text-sm text-ng-dark/80 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
